const STAGE = 'staging5';
// export const BASE_URL = `https://1aktz9jkzk.execute-api.us-west-2.amazonaws.com/${STAGE}`;
// export const BASE_URL = `http://localhost:3000`;
export const BASE_URL = `https://7lrxfwracl.execute-api.us-west-2.amazonaws.com/production`;
